import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { AddCardButton, InstoreRebate, Disclaimer } from 'core/modules/Instore2/partials';
import { InstoreMotto, useToggleDetailsButton } from '../partials';

import config from '../configs';

function WithoutAnyCardsView({ offer, isOpenByDefault }) {
  const { disclaimerTitle } = config;
  const { disclaimer, offerId, rclonMerchantName } = offer;

  const { ToggleDetailsButton, toggleDetails, isDetailsExpanded } = useToggleDetailsButton(isOpenByDefault);

  return (
    <div
      id="instore"
      className="mn_meInstoreOffer mn_withoutAnyCardsViews"
      data-merchant-name={rclonMerchantName}
    >
      <div className="mn_mainDetails">
        <div className="mn_leftSection">
          <InstoreMotto />
          <InstoreRebate offer={offer} />
        </div>
        <div className="mn_rightSection">
          <AddCardButton offerId={offerId} merchantName={rclonMerchantName} />
          <ToggleDetailsButton toggleDetails={toggleDetails} isDetailsExpanded={isDetailsExpanded} />
        </div>
      </div>
      {isDetailsExpanded &&
        <div className="mn_moreDetails">
          <Disclaimer title={disclaimerTitle}>{disclaimer}</Disclaimer>
        </div>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><WithoutAnyCardsView {...props} /></ComponentErrorBoundary>;
